import React, { forwardRef } from 'react';

import { Action, ActionProps } from '../Action';

export const Handle = forwardRef<HTMLButtonElement, ActionProps>(
	(props, ref) => (
		<Action
			ref={ref}
			cursor="grab"
			data-cypress="draggable-handle"
			{...props}
		>
			<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1.66642 7.1665C2.03461 7.1665 2.33309 6.86803 2.33309 6.49984C2.33309 6.13165 2.03461 5.83317
					1.66642 5.83317C1.29823 5.83317 0.999756 6.13165 0.999756 6.49984C0.999756 6.86803 1.29823 7.1665
					1.66642 7.1665Z"
					stroke="#C2C2C2"
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.66642 2.49984C2.03461 2.49984 2.33309 2.20136 2.33309 1.83317C2.33309 1.46498 2.03461 1.1665
					1.66642 1.1665C1.29823 1.1665 0.999756 1.46498 0.999756 1.83317C0.999756 2.20136 1.29823 2.49984
					1.66642 2.49984Z"
					stroke="#C2C2C2"
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.66642 11.8332C2.03461 11.8332 2.33309 11.5347 2.33309 11.1665C2.33309 10.7983 2.03461
					10.4998 1.66642 10.4998C1.29823 10.4998 0.999756 10.7983 0.999756 11.1665C0.999756 11.5347
					1.29823 11.8332 1.66642 11.8332Z"
					stroke="#C2C2C2"
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.33309 7.1665C6.70128 7.1665 6.99976 6.86803 6.99976 6.49984C6.99976 6.13165 6.70128
					5.83317 6.33309 5.83317C5.9649 5.83317 5.66642 6.13165 5.66642 6.49984C5.66642 6.86803
					5.9649 7.1665 6.33309 7.1665Z"
					stroke="#C2C2C2"
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.33309 2.49984C6.70128 2.49984 6.99976 2.20136 6.99976 1.83317C6.99976 1.46498 6.70128
					1.1665 6.33309 1.1665C5.9649 1.1665 5.66642 1.46498 5.66642 1.83317C5.66642 2.20136 5.9649
					2.49984 6.33309 2.49984Z"
					stroke="#C2C2C2"
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.33309 11.8332C6.70128 11.8332 6.99976 11.5347 6.99976 11.1665C6.99976 10.7983
					6.70128 10.4998 6.33309 10.4998C5.9649 10.4998 5.66642 10.7983 5.66642 11.1665C5.66642
					11.5347 5.9649 11.8332 6.33309 11.8332Z"
					stroke="#C2C2C2"
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</Action>
	),
);
